import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Output} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {EntityData} from "@fedeltapointofsale/data-client";
import {FUIModalsService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-edit-grid-form-edit-modal",
    templateUrl: "edit-grid-form-edit-modal.component.html",
    styleUrls: ["./edit-grid-form-edit-modal.component.scss"],
})
export class EditGridFormEditModalComponent {

    formTemplateRef: ElementRef;
    formGroup: FormGroup;
    dataItem: EntityData<any>;
    formTitle: string;

    open: boolean = true;
    maxWidth: string = "600px";
    maxHeight: string = "900px";

    @Output() onConfirm: EventEmitter<boolean> = new EventEmitter();

    constructor(private changeDetectorRef: ChangeDetectorRef,
                private modalsService: FUIModalsService) {
    }

    setup(formTemplateRef: ElementRef, formGroup: FormGroup, dataItem: EntityData<any>, formTitle: string): void {
        this.formTemplateRef = formTemplateRef;
        this.formGroup = formGroup;
        this.dataItem = dataItem;
        this.formTitle = formTitle;

        this.changeDetectorRef.detectChanges();
    }

    cancel(): void {
        this.onConfirm.emit(false);

        this.modalsService.close(this);
    }

    save(): void {
        if (this.formGroup.pending) {
            setTimeout(() => this.save(), 200);
            return;
        }
        if (!this.formGroup.valid) {
            this.markControlsAsTouched(this.formGroup);
            this.changeDetectorRef.detectChanges();
            return;
        }

        this.onConfirm.emit(true);

        this.modalsService.close(this);
    }

    markControlsAsTouched(formGroup: FormGroup): void {
        for (const key in formGroup.controls) {
            if (formGroup.controls[key] instanceof FormGroup) {
                this.markControlsAsTouched(<FormGroup>formGroup.controls[key]);
            } else {
                formGroup.controls[key].markAsTouched({onlySelf: false});
                formGroup.controls[key].updateValueAndValidity();
            }
        }
    }
}
